import { render } from "./RFIDTable.vue?vue&type=template&id=2c0920a2&ts=true"
import script from "./RFIDTable.vue?vue&type=script&lang=ts"
export * from "./RFIDTable.vue?vue&type=script&lang=ts"

import "./RFIDTable.vue?vue&type=style&index=0&id=2c0920a2&lang=css"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__